import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { addError } from 'actions';
import { getUserFiles, updateUserFile, deleteUserFile } from 'actions/user';
import { addTagsOnFile, removeTagOnFile } from 'actions/tags';
import Modal from 'containers/Modals/Modal';
import FileUpload from 'containers/Forms/FileUpload';
import FileForm from 'containers/Forms/File';
import { Block, Flex, Icon, Button, TooltipMenu, translate, getActiveLanguage } from '@haldor/ui';
import { Collapsible, Spinner } from 'UI';
import './_userFileArchive.scss';

var UserFileArchive = /*#__PURE__*/function (_Component) {
  _inherits(UserFileArchive, _Component);

  var _super = _createSuper(UserFileArchive);

  function UserFileArchive(props) {
    var _this;

    _classCallCheck(this, UserFileArchive);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getUserFiles(_this.props.user).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_sortAlphabetically", function (a, b) {
      if (a.toUpperCase() < b.toUpperCase()) return -1;
      if (b.toUpperCase(0) < a.toUpperCase()) return 1;
      return 0;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      return _this.setState({
        uploadModal: !_this.state.uploadModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFileEdit", function (file) {
      return _this.setState({
        activeFile: file
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeEditModal", function () {
      return _this.setState({
        activeFile: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectTag", function (tag) {
      return _this.setState({
        selectedTag: tag
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFileDelete", function (file) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('This file will be deleted permanently'),
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes'),
        preConfirm: function () {
          var _preConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this.props.deleteUserFile(_this.props.user, file.id)["catch"](function () {
                      var translate = _this.props.translate;

                      _this.props.addError(translate('something-went-wrong'), 'error');
                    });

                  case 2:
                    swal.close();

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function preConfirm() {
            return _preConfirm.apply(this, arguments);
          }

          return preConfirm;
        }()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFileArchive", function (file) {
      _this.onFileUpdate(_objectSpread(_objectSpread({}, file), {}, {
        archived: !file.archived
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onFileSubmit", function (values) {
      return new Promise(function (resolve) {
        var addTagsOnFile = _this.props.addTagsOnFile;
        var lang = getActiveLanguage();
        var tags = [];
        var promises = [];

        if (values.tags != null) {
          values.tags.forEach(function (tag) {
            tags.push(_objectSpread({
              lcid: lang.code
            }, tag));
          });
        }

        if (tags.length > 0) {
          values.files.forEach(function (file) {
            promises.push(addTagsOnFile(file.id, tags));
          });
        }

        Promise.all(promises).then(function () {
          _this.props.getUserFiles(_this.props.user);

          resolve(1);

          _this.toggleModal();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFileUpdate", function (values) {
      return new Promise(function (resolve) {
        var file = _this.props.files.find(function (file) {
          return file.id == values.id;
        });

        var lang = getActiveLanguage();
        var promises = [];

        var newTags = _toConsumableArray(values.tags.filter(function (tag) {
          return tag.id == null;
        }));

        var oldTags = _toConsumableArray(file.tags.filter(function (tag) {
          return values.tags.find(function (currentTag) {
            return currentTag.name == tag.name;
          }) == null;
        }));

        if (newTags.length > 0) {
          var tags = [];
          newTags.forEach(function (tag) {
            tags.push(_objectSpread({
              lcid: lang.code,
              tenantId: 0
            }, tag));
          });
          promises.push(_this.props.addTagsOnFile(values.id, tags));
        }

        if (oldTags.length > 0) {
          oldTags.forEach(function (tag) {
            promises.push(_this.props.removeTagOnFile(values.id, tag.id));
          });
        }

        promises.push(_this.props.updateUserFile(_this.props.user, values));
        Promise.all(promises).then(function () {
          _this.props.getUserFiles(_this.props.user);

          _this.closeEditModal();

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFile", function (file, index) {
      var translate = _this.props.translate;
      var visible = true;

      if (_this.state.selectedTag != null) {
        visible = file.tags.find(function (tag) {
          return tag.name == _this.state.selectedTag;
        }) != null;
      }

      if (!visible) {
        return null;
      }

      return /*#__PURE__*/React.createElement("a", {
        href: file.url,
        target: "_blank",
        key: 'file-' + index,
        className: "file"
      }, /*#__PURE__*/React.createElement("div", {
        className: "df aic"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "File"
      }), file.name, file.tags != null && file.tags.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "tags"
      }, file.tags.map(function (tag, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'filetag-' + index,
          className: "tag"
        }, tag.name);
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "df aic"
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: /*#__PURE__*/React.createElement(Icon, {
          name: "Bullets"
        })
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onFileEdit(file);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", translate('Edit tags')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onFileArchive(file);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Archive"
      }), " ", file.archived ? translate('Restore') : translate('Archive')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onFileDelete(file);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), " ", translate('Delete')))));
    });

    _this.state = {
      selectedTag: null,
      uploadModal: false,
      loading: true
    };
    return _this;
  }

  _createClass(UserFileArchive, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var translate = this.props.translate;
      var tags = [];
      var files = [];
      var archivedFiles = [];
      this.props.files.forEach(function (file) {
        if (file.tags != null) {
          file.tags.forEach(function (tag) {
            if (tags.indexOf(tag.name) == -1) {
              tags.push(tag.name);
            }
          });
        }
      });
      files = _toConsumableArray(this.props.files).filter(function (file) {
        return !file.archived;
      }).sort(function (a, b) {
        return _this2._sortAlphabetically(a.name, b.name);
      });
      archivedFiles = _toConsumableArray(this.props.files).filter(function (file) {
        return file.archived;
      }).sort(function (a, b) {
        return _this2._sortAlphabetically(a.name, b.name);
      });

      if (tags.length > 0) {
        tags = tags.sort(this._sortAlphabetically);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "user-file-archive"
      }, /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        title: translate('upload-files'),
        isOpen: this.state.uploadModal,
        onClose: this.toggleModal
      }, /*#__PURE__*/React.createElement(FileUpload, {
        userId: this.props.user,
        onSubmit: this.onFileSubmit,
        onCancel: this.toggleModal
      })), /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        title: translate('Edit tags'),
        isOpen: this.state.activeFile != null,
        onClose: this.closeEditModal
      }, /*#__PURE__*/React.createElement(FileForm, {
        onCancel: this.closeEditModal,
        onSubmit: this.onFileUpdate,
        initialValues: this.state.activeFile
      })), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        className: "sider"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: translate('Tags'),
        open: true
      }, tags.map(function (tag, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'tag-' + index
        }, /*#__PURE__*/React.createElement("div", {
          className: "tag",
          onClick: function onClick() {
            return _this2.onSelectTag(tag);
          }
        }, tag));
      }), this.state.selectedTag != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '0.25rem',
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this2.setState({
            selectedTag: null
          });
        }
      }, this.props.translate('show-all')) : null)), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Files'), this.state.selectedTag != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          position: 'relative',
          top: '-1px',
          marginLeft: '.55rem',
          cursor: 'pointer'
        },
        className: "color--meta size-12",
        onClick: function onClick() {
          return _this2.setState({
            selectedTag: null
          });
        }
      }, "#", this.state.selectedTag) : null), /*#__PURE__*/React.createElement("div", {
        className: "files"
      }, files.map(this.renderFile), archivedFiles.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "archived-files"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: translate('archived')
      }, archivedFiles.map(this.renderFile))) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      }), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), translate('upload-files'))))));
    }
  }]);

  return UserFileArchive;
}(Component);

function mapStateToProps(state) {
  return {
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    files: state.user.files
  };
}

export default connect(mapStateToProps, {
  getUserFiles: getUserFiles,
  addTagsOnFile: addTagsOnFile,
  updateUserFile: updateUserFile,
  removeTagOnFile: removeTagOnFile,
  deleteUserFile: deleteUserFile,
  addError: addError
})(UserFileArchive);